import * as React from "react"
import { Flex } from "@chakra-ui/react"
import { BigPlayIcon, Button } from "./big-play-button.styled"
import { useTouchHandle } from "../../../../hooks/useTouchHandle"
import { BigPlayButtonProps } from "./big-play-button.interface"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../../recoil/atoms/room"

const _BigPlayButton: React.FC<BigPlayButtonProps> = ({
  enabled,
  handlePlay,
  offTouch,
  height,
  width
}): JSX.Element => {
  const { handleOnTouchEnd, handleTouchStart } = useTouchHandle()

  const roomStyles = useRecoilValue(brandingSelector)

  if (!enabled) {
    return null
  }
  return (
    <Flex
      background="rgba(255,255,255,0.4)"
      id="play-button"
      width={width ?? "100%"}
      height={height ?? "100%"}
      position="absolute"
      zIndex={1000000000}
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
      onClick={offTouch ? event => handlePlay(event) : null}
      onTouchStart={offTouch ? null : event => handleTouchStart(event)}
      onTouchEnd={
        offTouch
          ? null
          : event => handleOnTouchEnd(event, () => handlePlay(event))
      }  
    >
      <Button
        onClick={offTouch ? event => handlePlay(event) : null}
        onTouchStart={offTouch ? null : event => handleTouchStart(event)}
        onTouchEnd={
          offTouch
            ? null
            : event => handleOnTouchEnd(event, () => handlePlay(event))
        }
      >
        <BigPlayIcon roomStyles={roomStyles} />
      </Button>
    </Flex>
  )
}

export const BigPlayButton = React.memo(_BigPlayButton)
